import EmailForm from 'components/emailer/form/email-form';
import { Loading, Button } from '@evertrue/et-components';
import PropTypes from 'prop-types';
import useEmailer from 'components/emailer/hooks/use-emailer';
import GoogleDisclosure from 'components/emailer/google-disclosure';
import { EmailTemplatesProvider } from 'apps/outreach/email/templates/email-templates-context';
import { EmailSignaturesProvider } from 'apps/outreach/email/signatures/email-signatures-context';

const EmailerController = ({
  taskId,
  name,
  handleClose,
  setDrawerTitle,
  contact,
  email,
  closeDrawer = () => {},
  drawerId,
  clickedEmailAddress = '',
}) => {
  const { loading, emailerIsConnected, handleConnectEmail, provider } = useEmailer();

  if (loading) return <Loading spinner_size="large" />;

  if (emailerIsConnected)
    return (
      <EmailSignaturesProvider>
        <EmailTemplatesProvider>
          <EmailForm
            contact={contact}
            email={email}
            taskId={taskId}
            closeDrawer={closeDrawer}
            handleClose={handleClose}
            setDrawerTitle={setDrawerTitle}
            drawerId={drawerId}
            provider={provider}
            clickedEmailAddress={clickedEmailAddress}
          />
        </EmailTemplatesProvider>
      </EmailSignaturesProvider>
    );
  if (emailerIsConnected !== null)
    return (
      <div style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
        <div className="oauth-controller">
          <h1>Connect Your Account</h1>
          <p>Link your account to start using email services here</p>
          <div className="email-disconnect-alert">
            After successfully connecting your email account for the first time, your account will be disconnected every
            31 days for security reasons. Please reconnect to continue using your email in EverTrue.
          </div>
          <div>
            <Button className="oauth-provider--btn" onClick={handleConnectEmail}>
              Connect
            </Button>
          </div>
        </div>
        <GoogleDisclosure style={{ textAlign: 'center', padding: '0 45px 50px' }} />
      </div>
    );
  return (
    <div className="oauth-controller">
      <h2 style={{ textAlign: 'center' }}>There was a problem fetching your credentials.</h2>
      <p>Please contact genius@evertrue.com if the problem persists.</p>
    </div>
  );
};

EmailerController.propTypes = {
  taskId: PropTypes.number,
  email: PropTypes.object,
  name: PropTypes.string,
  handleClose: PropTypes.func,
  setDrawerTitle: PropTypes.func,
  contact: PropTypes.object,
  closeDrawer: PropTypes.func,
  drawerId: PropTypes.string,
  clickedEmailAddress: PropTypes.string,
};

export default EmailerController;
